import { cx } from '@emotion/css';
import styles from './CardInfo.styles';
import { BodyLargeEmphasized, BodyMediumMidEmphasis, TitleMediumEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import { AccessibleDivButton } from '@/components';

interface CardInfoProps {
  id: string;
  title: string;
  amount: number;
  frequency: string;
  goToFlyers: (title: string, id: string) => void;
  dataTestId: string;
}
const CardInfo: React.FC<CardInfoProps> = ({
  id,
  title,
  amount,
  frequency,
  goToFlyers,
  dataTestId,
}) => (
  <AccessibleDivButton
    className={styles.container}
    onClick={() => goToFlyers(title, id)}
    data-testid={dataTestId}
    role='link'
  >
    <BodyLargeEmphasized
      className={cx(styles.title, styles.variants[title.toLowerCase()])}
      data-testid="title"
    >
      {title}
    </BodyLargeEmphasized>
    <TitleMediumEmphasized data-testid="amount">
      {amount}
    </TitleMediumEmphasized>
    <BodyMediumMidEmphasis color={colors.slate} data-testid="frequency">
      {frequency}
    </BodyMediumMidEmphasis>
  </AccessibleDivButton>
);

export default CardInfo;
